import React, { useState } from "react";
import { FaAndroid, FaDesktop, FaGlobe, FaMobileAlt, FaShoppingCart, FaUserTie } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import categorys from '../../../assets/Docs/categoryView.png'
import { TagComponent } from "../Tabs";

const Categories = () => {

  const [activeTab, setActiveTab] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    { id: "mobile", label: "Mobile App", icon: <FaMobileAlt /> },
  ];


  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <MdCategory className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Categories</h1>
      </div>


      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <p className="text-gray-600 mb-6 text-start">
        Categories enable you to arrange your products into manageable groups. One product can be included in multiple categories. Selzor enables you to import products and their categories (upto 3 categories at the time of import) from an Excel file. Once the categories have been imported or set, you can nest them further to facilitate navigation.</p>

      <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => tab.id !== "mobile" && setActiveTab(tab.id)} // prevent click for mobile
            disabled={tab.id === "mobile"} // disable mobile tab
            className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto
        ${tab.id === "mobile"
                ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]"
                : activeTab === tab.id
                  ? "bg-[#1a9588] text-white shadow"
                  : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
              }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>


      { }
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={categorys}
          alt={`${activeTab} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>
      <div className="text-start py-5">
        <div>
          <h3 className="text-gray-600 font-semibold text-lg pb-3">Related Topics</h3>
          <div className="text-sm text-gray-500">
            <div><a href="category-nesting" className=" hover:underline hover:text-[#1a9588]">Category Nesting</a></div>
            {/* <div><a href="reorder-products" className=" hover:underline hover:text-[#1a9588]">Reorder Products</a></div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Categories